// ABOUTME: Step 2 of MFA setup - verifies the TOTP code from the authenticator app.
// ABOUTME: Calls verify-setup endpoint and stores recovery codes on success.
import { Box, useTheme } from "@mui/material";
import OtpInput from "../../../../theme/inputs/OtpInput";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import ProgressionTab from "../../../../theme/ProgressionBuilder/ProgressionTab";
import Text from "../../../../theme/text/Text";
import Shbutton from "../../../../theme/buttons/Shbutton";
import { tokens } from "../../../../../theme";
import { useVerifyMfaSetupMutation } from "../../../../../newapi/user/mfaSlice";
import { setCurrentTab, updateData } from "../../../../../newapi/global/progressionTabSlice";

const Content = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [code, setCode] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [verifyMfaSetup, { isLoading }] = useVerifyMfaSetupMutation();

    const handleVerify = async (codeOverride) => {
        setErrorMessage("");
        try {
            const result = await verifyMfaSetup({ code: codeOverride || code }).unwrap();
            if (result.success) {
                dispatch(updateData({ recoveryCodes: result.data.recoveryCodes }));
                dispatch(setCurrentTab("tabRecoveryCodes"));
            } else {
                setErrorMessage(result.error || t("invalid_code_try_again"));
            }
        } catch (err) {
            setErrorMessage(err?.data?.error || t("invalid_code_try_again"));
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && code.length === 6) {
            handleVerify();
        }
    };

    return (
        <Box sx={{ textAlign: "center", py: 4, px: 2 }}>
            <Text light sx={{ mb: 4, maxWidth: 320, mx: "auto" }}>
                {t("enter_6_digit_code")}
            </Text>

            <Box sx={{ mb: 3 }}>
                <OtpInput
                    value={code}
                    onChange={(val) => { setCode(val); setErrorMessage(""); }}
                    onComplete={(val) => handleVerify(val)}
                    error={!!errorMessage}
                    autoFocus
                />
            </Box>

            {errorMessage && (
                <Text sx={{ color: colors.red[400], mb: 2 }}>
                    {errorMessage}
                </Text>
            )}

            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Shbutton
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    variant="contained"
                    onClick={handleVerify}
                    disabled={code.length !== 6}
                    isLoading={isLoading}
                >
                    {t("verify")}
                </Shbutton>
            </Box>
        </Box>
    );
};

const VerifyCode = (props) => {
    const { t } = useTranslation();

    return (
        <ProgressionTab
            tabId="tabVerifyCode"
            subtitle={t("verify_authenticator")}
            step={2}
            maxSteps={3}
            nextTab="tabRecoveryCodes"
            removeButtons
        >
            <Content />
        </ProgressionTab>
    );
};

export default VerifyCode;
